var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import PropTypes from "prop-types";
import React, { Component } from "react";

import { DEFAULT_TABS_STYLES } from "../../constants.js";

var Tabs = function (_Component) {
  _inherits(Tabs, _Component);

  function Tabs(props, context) {
    _classCallCheck(this, Tabs);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

    _this.state = {
      activeTabIndex: 0 // The first tab is active by default
    };
    return _this;
  }

  Tabs.prototype.setActiveTabIndex = function setActiveTabIndex(activeTabIndex) {
    this.setState({ activeTabIndex: activeTabIndex });
  };

  Tabs.prototype.renderPanels = function renderPanels() {
    var activeTabIndex = this.state.activeTabIndex;
    var children = this.props.children;


    return React.Children.map(children, function (child, i) {
      return activeTabIndex === i && child.props.children;
    });
  };

  Tabs.prototype.renderTabs = function renderTabs() {
    var _this2 = this;

    var activeTabIndex = this.state.activeTabIndex;

    var _props = this.props,
        children = _props.children,
        className = _props.className,
        color = _props.color,
        style = _props.style,
        tabsProps = _objectWithoutProperties(_props, ["children", "className", "color", "style"]);

    return React.createElement(
      "div",
      _extends({
        className: className,
        style: _extends({}, style, color ? { borderBottomColor: color } : {})
      }, tabsProps),
      React.Children.map(children, function (child, i) {
        var _child$props = child.props,
            tabColor = _child$props.color,
            label = _child$props.label,
            _onClick = _child$props.onClick,
            childProps = _objectWithoutProperties(_child$props, ["color", "label", "onClick"]);

        return React.cloneElement(child, Object.assign({
          color: color, // Spred "Tabs" color prop to "Tab" component
          label: label ? label : "Tab " + i // Prevent empty tab
        }, childProps, _extends({
          active: activeTabIndex === i
        }, tabColor ? { color: tabColor } : {}, { // Override "Tabs" color prop if "Tab" color prop isset
          onClick: function onClick(e) {
            _this2.setActiveTabIndex(i);
            _onClick && _onClick(e, i);
          }
        })));
      })
    );
  };

  Tabs.prototype.render = function render() {
    return React.createElement(
      "div",
      null,
      this.renderTabs(),
      this.renderPanels()
    );
  };

  return Tabs;
}(Component);

Tabs.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.arrayOf(PropTypes.element).isRequired,
  className: PropTypes.string,
  color: PropTypes.string,
  style: PropTypes.object
} : {};

Tabs.defaultProps = {
  className: null,
  color: null,
  style: DEFAULT_TABS_STYLES
};

export default Tabs;